import { makeApiRequest } from '../../lib/http/makeApiRequest';
import { CreatedDevToken, DevToken } from '../../types/dev-token.types';

export const createDevToken = async (): Promise<CreatedDevToken> => {
  return makeApiRequest('/v1/auth/dev-token', { method: 'POST' });
};

export const fetchDevTokens = async (): Promise<DevToken[]> => {
  return makeApiRequest('/v1/auth/dev-token', { method: 'GET' });
};

export const revokeDevToken = async (tokenId: string): Promise<void> => {
  await makeApiRequest(`/v1/auth/dev-token/${tokenId}`, { method: 'DELETE' });
};
